<template>
  <div>
    <div
        class="text-center mt-16"
        v-if="dataFetching"
    >
      <v-progress-circular
          indeterminate
          color="primary"
      ></v-progress-circular>
    </div>
    <v-alert
        color="grey"
        text
        v-if="proposals.length === 0 && dataFetching === false"
    >No proposal record found
    </v-alert>

    <PaginatedList
        v-if="proposals.length > 0"
        :items="proposals"
        :itemsPerPage="5"
        :pageChangeCallback="paginatedListPageChangeCallback"
    >
      <template v-slot:content="{items,itemsPerPage, page}">
        <v-row>
          <v-col
              v-for="(proposal, index) in items"
              :key="index"
              cols="12"
          >
            <ProposalCard
                v-if="proposal.proposalContent"
                :proposalData="proposal.proposalData"
                :proposalContent="proposal.proposalContent"
                :votingResult="votingResults[itemsPerPage * (page-1) + index]"
                :votedOption="votingRecordsObj[proposal.proposalData.proposalId]"
                :editable="editable"
            >
              <template v-slot:voteConfirm="{proposalData, selectedOption}">
                <slot name="voteConfirm" v-bind="{proposalData, selectedOption}"></slot>
              </template>
            </ProposalCard>
          </v-col>
        </v-row>
      </template>
    </PaginatedList>
  </div>
</template>

<script>

import ProposalCard from "@/components/ProposalList/ProposalCard";
import store from "@/store/index"
import backendCall from "@/lib/backendCall";
import PaginatedList from "@/components/PaginatedList";

export default {
  name: "ProposalList",
  components: {
    PaginatedList,
    ProposalCard
  },
  props: {
    storeAccount: String,
    editable: Boolean
  },
  async mounted() {
    await this.fetchProposalData()
  },
  computed: {
    proposals() {
      let proposals = []
      for (let i = 0; i < this.proposalData.length; i++) {
        proposals[i] = {
          proposalData: this.proposalData[i],
          proposalContent: this.proposalContents[i]
        }
      }
      return proposals
    },
    votingRecordsObj() {
      const votingRecords = {}
      for (let i=0; i<this.votingRecords.length; i++) {
        votingRecords[this.votingRecords[i].proposalId] = this.votingRecords[i].option
      }
      return votingRecords
    }
  },
  data() {
    return {
      proposalData: [],
      proposalContents: [],
      votingRecords: [],
      votingResults: [],
      dataFetching: false
    }
  },
  methods: {
    async fetchProposalData() {
      try {
        this.dataFetching = true
        const res = await backendCall.proposal.getProposalsAndMyVotingRecords(this.storeAccount, store.state.loggedInAccount)
        if (res.status === 1) {
          this.proposalData = res.data.proposalData
          this.votingRecords = res.data.customerVotingRecords

          for (let i=0; i<this.proposalData.length; i++) {
            let votingResult = {};
            for (let j=0; j<this.proposalData[i].polling.length; j++){
              votingResult[this.proposalData[i].polling[j].option] = this.proposalData[i].polling[j].voteCount
            }
            // this.votingRecords = this.votingRecords.unshift(votingResult)
            this.$set(this.votingResults, i, votingResult)
          }
          // let promiseArray = []
          // for (let i = 0; i < this.proposalData.length; i++) {
          //   promiseArray.push(backendCall.proposal.getProposalContent(this.proposalData[i].uri))
          // }
          // const promiseArrayRes = await Promise.all(promiseArray)
          // for (let i = 0; i < promiseArrayRes.length; i++) {
          //   console.log("res: ", promiseArrayRes[i])
          //   this.$set(this.proposalContents, i, (promiseArrayRes[i].status === 1 ? promiseArrayRes[i].data : null))
          // }
        }
      }catch (e) {
        console.log(e)
      }finally {
        this.dataFetching = false
      }
    },
    paginatedListPageChangeCallback(items, page, itemsPerPage) {
      for (let i=((page-1) * itemsPerPage); i<page*itemsPerPage && i<this.proposalData.length; i++) {
        if (!this.proposalContents[i]) {
          backendCall.proposal.getProposalContent(
              this.proposalData[i].uri
          ).then((res) => {
            if (res.status === 1){
              this.$set(this.proposalContents, i, res.data)
            }
          })
        }
      }
    }
  }
}
</script>

<style scoped>

</style>